import {absCenter, clearfix, font_s_sm} from '@xpertdox_js/xdstyle';
import {colors} from '../defaultSettings';

export default {
  container: {
    ...clearfix,
    // borderBottom: 'none',
    // background: colors.bg.toolbarTop,
  },
  button: {
    ...font_s_sm,
    position: 'relative',
    height: '36px',
    float: 'left',
    borderBottom: 'none',
    zIndex: 1,
    // transform: 'translateY(20%)',
    cursor: 'pointer',
    color: colors.toolbarTopText,
    border: 'none',
    background: 'none',
    marginLeft: '-5px',
    transition: 'background .25s, color .25s'
  },
  buttonWrap: {
    width: '95%',
    height: '100%',
    background: colors.bg.toolbarTop,
    // borderRight: '1px solid ' + colors.toolbarTopBorder,
    // borderTop: '1px solid ' + colors.toolbarTopBorderLt,
    // borderLeft: '1px solid ' + colors.toolbarTopBorderLt,
    boxShadow: '0 -1px 5px rgba(0,0,0,0.1)',
    display:  'block',
    position: 'absolute',
    top: 0, left: 0,
    borderTopLeftRadius: '3px'
  },
  buttonWrapActive: {
    background: colors.bg.toolbarTopAct,
  },
  buttonEdge: {
    width: '5%',
    height: '100%',
    // border: '36px solid #000',
    // borderTopColor: 'transparent',
    // borderRightColor: 'transparent',
    // borderBottomColor: 'transparent',
    position: 'absolute',
    right: 0,
    top: 0,
    // transform: 'translateX(80%)',
    left: 'auto',
    display: 'block',
    fill: colors.bg.toolbarTop,
  },
  buttonEdgeActive: {
    fill: colors.bg.toolbarTopAct,
  },
  buttonEdgeSvg: {
    position: 'absolute',
    left: 0, right: 'auto', top: 0,
    height: '100%',
    width: 'auto'
  },
  buttonHov: {
    // background: colors.bg.toolbarTopHov,
    color: colors.toolbarTopTextHov || colors.toolbarTopText,
    // transform: 'translateY(0%)',
  },
  buttonAct: {
    // background: colors.bg.toolbarTopAct,
    color: colors.toolbarTopTextAct || colors.toolbarTopText,
    // transform: 'translateY(0%)',
    // boxShadow: '0 -1px 5px rgba(0,0,0,0.06)'
  },
  buttonText: {
    display: 'block',
    ...absCenter,
  }
}
